import {initCategoryPage} from './layout/category-page'
import {initFrontPage}  from './layout/front-page'
import {initHeader} from './layout/header'
import {initSingleCompany} from './layout/single-company'
import {initSearch} from "./elements/search"
import {initAdBlock} from "./layout/blocks/ad";


jQuery(() => {
    initHeader()
    initFrontPage()
    initCategoryPage()
    initSingleCompany()
    initSearch()
    initAdBlock()
})
